export default function Box ({ className, children }) {
    return (
        <div className={`bg-white p-6 rounded shadow-2xl text-center ${className}`}>
            { children }
        </div>
    )
}